import gql from 'graphql-tag';

export const MESSAGE_FRAGMENT = gql`
  fragment MessageFragment on Message {
    id
    chat_id
    sender_user_id
    sender_account_id
    recipient_account_id
    estimate_id
    job_id
    invoice_id
    senderFirstName
    senderLastName
    senderAvatarUrl
    senderAccountName
    text
    isInternal
    isArchived
    attachments {
      id
      job_id
      account_id
      creator_user_id
      creatorFullName
      client_account_id
      service_item_id
      estimate_id
      property_id
      note_id
      message_id
      invoice_id
      fileName
      fileSize
      mimeType
      base64
      isInternal
      type
      createdAt
      updatedAt
    }
    createdAt
    updatedAt
  }
`;
